module.exports = __webpack_public_path__ + "img/hg.8e71f944.webp";